import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _JSXStyle from "styled-jsx/style";
import { useState, useMemo, useCallback, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Link from 'next/link';
import { classnames } from '@@client/lib/classes';
import { preventDefault } from '@@client/lib/events';
import { TriggerManager } from '@@client/lib/util';
import { useConfig, useChat, usePreloadImages } from '@@client/lib/hooks';
import { respondStatus, withErrorPage } from '@@client/lib/nextjs';
import { formatNumber, formatDollars } from '@@client/lib/numbers';
import { labelStyle, subHeadingStyle, valueStyle } from '@@client/parts/styles';
import { getPartSummary, hasRetailPrice } from '@@client/parts/parts-helper';
import { useDefaultWarrantyInfo, useWarrantyOptions } from '@@client/cart/cart-hooks';
import { useLastSearch, getSearchUrl } from '@@client/parts/search-repo';
import { getOnePart } from '@@client/parts/inventory/actions';
import { addRecentlyViewed } from '@@client/cart/actions';
import loadVehiclePhotos from '@@client/media/loadVehiclePhotos';
import loadInventoryPhotos from '@@client/media/loadInventoryPhotos';
import { getFallbackUrlByPartType, getImageSizeUrl } from '@@client/media/api';
import Layout from '@@client/app/Layout';
import Carousel, { Indicators } from '@@client/components/Carousel';
import FadeIn from '@@client/components/FadeIn';
import Loading from '@@client/components/Loading';
import Img from '@@client/components/Img';
import Youtube from '@@client/components/Youtube';
import PartPhoto from '@@client/parts/PartPhoto';
import { SubLayoutGraySidebar, Sidebar, Main } from '@@client/app/SubLayoutGraySidebar';
import CoreChargeMessage from '@@client/checkout/CoreChargeMessage';
import WarrantyOptionCard from '@@client/cart/WarrantyOptionCard';
import PartCartActions from '@@client/parts/PartCartActions';
import RecentlyViewedParts from '@@client/parts/RecentlyViewedParts';
import PartSearchFormSidebar from '@@client/parts/PartSearchFormSidebar';
import FeaturedPartTypesSidebar from '@@client/parts/part-type/FeaturedPartTypesSidebar';
var standardContainerPaddingTb = '12px';
var standardContainerPaddingStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "2406320583",
    children: [".jsx-2406320583{padding:".concat(standardContainerPaddingTb, " 14px;}")]
  }),
  className: "jsx-2406320583"
};
var standardContainerMarginStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "2092096594",
    children: [".jsx-2092096594{margin-bottom:5px;}"]
  }),
  className: "jsx-2092096594"
};

var OneThumbnail = function OneThumbnail(_ref) {
  var src = _ref.src,
      controls = _ref.controls,
      alt = _ref.alt,
      isFeatured = _ref.isFeatured,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  var classNames = classnames(['m--clickable', isFeatured ? 'is-featured' : null]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": "View a larger version of this photo.",
      "aria-controls": controls,
      onClick: preventDefault(function () {
        return onClick();
      }),
      className: "jsx-394903072" + " " + (classNames || ""),
      children: /*#__PURE__*/_jsx(Img, {
        src: src,
        alt: alt
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "394903072",
      children: ["button.jsx-394903072{border:1px solid transparent;-webkit-transition:all 200ms ease;-webkit-transition:all 200ms ease;transition:all 200ms ease;padding:3px;background:transparent;}", "button.jsx-394903072:hover,button.is-featured.jsx-394903072{border-color:#4B62A0;}"]
    })]
  });
};

var Thumbnails = function Thumbnails(_ref2) {
  var featuredImageIdx = _ref2.featuredImageIdx,
      imageEntities = _ref2.imageEntities,
      fallbackUrl = _ref2.fallbackUrl,
      partSummary = _ref2.partSummary,
      controls = _ref2.controls,
      _ref2$onClick = _ref2.onClick,
      _onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick;

  var config = useConfig();

  var imageUrlFromEntity = function imageUrlFromEntity(entity) {
    return getImageSizeUrl(config.media.apiUrl, 'preview', entity.parentId || entity.id);
  };

  var isFullLoaded = usePreloadImages(imageEntities.map(imageUrlFromEntity));
  if (!isFullLoaded) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: imageEntities.map(function (entity, i) {
      return /*#__PURE__*/_jsx(OneThumbnail, {
        controls: controls,
        isFeatured: featuredImageIdx === i,
        onClick: function onClick() {
          return _onClick(i);
        },
        src: imageUrlFromEntity(entity),
        alt: "Photo #".concat(i + 1, " of ").concat(partSummary)
      }, entity.id);
    })
  });
};

var FeaturedImageSlider = function FeaturedImageSlider(_ref3) {
  var partInfo = _ref3.partInfo,
      imageEntities = _ref3.imageEntities,
      fallbackUrl = _ref3.fallbackUrl,
      _ref3$onSlideChange = _ref3.onSlideChange,
      onSlideChange = _ref3$onSlideChange === void 0 ? function () {} : _ref3$onSlideChange,
      slideToTriggerManager = _ref3.slideToTriggerManager,
      partSummary = _ref3.partSummary;
  var config = useConfig();

  var imageUrlFromEntity = function imageUrlFromEntity(entity) {
    return getImageSizeUrl(config.media.apiUrl, 'large', entity.parentId || entity.id);
  };

  var _useState = useState(0),
      numSlides = _useState[0],
      setNumSlides = _useState[1];

  var _useState2 = useState(1),
      currentSlide = _useState2[0],
      setCurrentSlide = _useState2[1];

  var isFullLoaded = usePreloadImages(imageEntities.map(imageUrlFromEntity));
  slideToTriggerManager = slideToTriggerManager || useMemo(TriggerManager, []);
  var trackId = 'part-featured-images-track';
  var carouselClassNames = classnames(['carousel']);
  useEffect(function () {
    imageLoadedTriggerManager.trigger();
  }, [isFullLoaded]);

  var handleNumSlidesChange = function handleNumSlidesChange(numSlides) {
    setNumSlides(numSlides);
  };

  var handleSlideChange = function handleSlideChange(info) {
    setCurrentSlide(info.currentSlide);
    onSlideChange(info);
  };

  var imageLoadedTriggerManager = useMemo(TriggerManager, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-4112853324" + " " + 'container',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-4112853324" + " " + (carouselClassNames || ""),
        children: isFullLoaded ? /*#__PURE__*/_jsx(FadeIn, {
          children: /*#__PURE__*/_jsx(Carousel, {
            label: "Featured part photo",
            trackId: trackId,
            renderIndicators: false,
            onSlideChange: handleSlideChange,
            onNumSlidesChange: handleNumSlidesChange,
            triggerSlideTo: slideToTriggerManager ? slideToTriggerManager.setCallback : undefined,
            triggerResize: imageLoadedTriggerManager.setCallback,
            resizeOnChange: true,
            children: imageEntities.map(function (entity, i) {
              return /*#__PURE__*/_jsx(PartPhoto, {
                fillContainer: false,
                partInfo: partInfo,
                src: imageUrlFromEntity(entity),
                alt: "Photo #".concat(i + 1, " of ").concat(partSummary),
                onLoad: imageLoadedTriggerManager.trigger
              }, entity.id);
            })
          })
        }) : /*#__PURE__*/_jsx(PartPhoto, {
          fillContainer: false,
          partInfo: partInfo,
          src: fallbackUrl,
          alt: "Photo #1 of ".concat(partSummary)
        }, 'fallback')
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-4112853324" + " " + 'indicators',
        children: /*#__PURE__*/_jsx(Indicators, {
          onClick: slideToTriggerManager.trigger,
          controls: trackId,
          num: numSlides,
          currentSlide: currentSlide
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "4112853324",
      children: [".carousel.jsx-4112853324{position:relative;overflow:hidden;margin-bottom:10px;}", "@media(min-width:992px){.carousel.jsx-4112853324{margin-bottom:0;}}", ".carousel.jsx-4112853324 img{width:100%;height:auto;}", ".carousel.jsx-4112853324 .control{position:absolute;top:0;z-index:1;height:100%;}", ".carousel.jsx-4112853324 .control:before{content:'';display:block;width:46px;height:46px;position:absolute;background:rgba(21,24,36,0.50196);top:50%;-webkit-transform:translateY(-50%);-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:background 200ms ease;-webkit-transition:background 200ms ease;transition:background 200ms ease;}", ".carousel.jsx-4112853324 .control:hover:before{background:rgba(221,221,221,0.8);}", ".carousel.jsx-4112853324 .control:after{width:15px;height:15px;border-color:white;}", ".carousel.jsx-4112853324 .control:hover:after{border-color:#21409A;}", ".carousel.jsx-4112853324 .control-prev{left:0;padding:10px 5px 10px 18px;}", ".carousel.jsx-4112853324 .control-prev:before{left:0;}", ".carousel.jsx-4112853324 .control-next{right:0;padding:10px 18px 10px 5px;}", ".carousel.jsx-4112853324 .control-next:before{right:0;}", ".indicators.jsx-4112853324{text-align:center;}", "@media(min-width:992px){.indicators.jsx-4112853324{display:none;}}"]
    })]
  });
};

var PartHeading = function PartHeading(_ref4) {
  var _ref4$loading = _ref4.loading,
      loading = _ref4$loading === void 0 ? true : _ref4$loading,
      partInfo = _ref4.partInfo;
  if (loading) return null;
  var lastSearchData = useLastSearch();
  var goBackText = lastSearchData ? 'Back to search result' : 'Search more parts like this one';
  var searchData = lastSearchData || {
    part: partInfo.partTypeSlug,
    year: partInfo.modelYear,
    make: partInfo.makeName,
    model: partInfo.carlineName
  };
  var searchUrl = getSearchUrl(searchData);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-208822280" + " " + 'heading',
      children: [/*#__PURE__*/_jsx("h1", {
        className: "jsx-208822280",
        children: partInfo.partTypeName
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-208822280",
        children: /*#__PURE__*/_jsx(Link, {
          href: searchUrl,
          children: /*#__PURE__*/_jsx("a", {
            className: "jsx-208822280" + " " + (classnames('c--back', subHeadingStyle.className) || ""),
            children: goBackText
          })
        })
      })]
    }), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "208822280",
      children: [".heading.jsx-208822280{border-bottom:2px solid #21409A;padding-bottom:5px;margin-bottom:15px;}", "@media(min-width:576px){.heading.jsx-208822280{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}}", "h1.jsx-208822280{margin:0 20px 0 0;line-height:1.2;}"]
    })]
  });
};

var PartPhotos = function PartPhotos(_ref5) {
  var config = _ref5.config,
      loading = _ref5.loading,
      partInfo = _ref5.partInfo,
      media = _ref5.media;
  if (loading) return /*#__PURE__*/_jsx(Loading, {});
  if (!partInfo) return null;

  var _useState3 = useState(null),
      carouselControlsId = _useState3[0],
      setCarouselControlsId = _useState3[1];

  var _useState4 = useState(0),
      featuredImageIdx = _useState4[0],
      setFeaturedImageIdx = _useState4[1];

  var imageEntities = [].concat(_toConsumableArray(media.listInventory.entities), _toConsumableArray(media.listVehicle.entities));
  var fallbackUrl = getFallbackUrlByPartType(partInfo.partType);
  var summary = getPartSummary(partInfo);
  var slideToTriggerManager = useMemo(TriggerManager, []);
  var handleSlideChange = useCallback(function (_ref6) {
    var currentSlide = _ref6.currentSlide,
        controls = _ref6.controls;
    setFeaturedImageIdx(currentSlide);
    setCarouselControlsId(controls);
  }, []);

  var onSlideChangeFromThumbnail = function onSlideChangeFromThumbnail(imageIdx) {
    slideToTriggerManager.trigger(imageIdx);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-1898632057" + " " + 'photos',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-1898632057" + " " + 'featured',
        children: /*#__PURE__*/_jsx(FeaturedImageSlider, {
          partInfo: partInfo,
          imageEntities: imageEntities,
          fallbackUrl: fallbackUrl,
          partSummary: summary,
          onSlideChange: handleSlideChange,
          slideToTriggerManager: slideToTriggerManager
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-1898632057" + " " + 'secondary a-lg',
        children: /*#__PURE__*/_jsx(Thumbnails, {
          controls: carouselControlsId,
          imageEntities: imageEntities,
          fallbackUrl: fallbackUrl,
          partSummary: summary,
          featuredImageIdx: featuredImageIdx,
          onClick: onSlideChangeFromThumbnail
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1898632057",
      children: [".photos.jsx-1898632057 .featured.jsx-1898632057{margin-bottom:20px;}", ".photos.jsx-1898632057 .secondary.jsx-1898632057{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:5px;}"]
    })]
  });
};

var PartDetails = function PartDetails(_ref7) {
  var loading = _ref7.loading,
      partInfo = _ref7.partInfo;
  if (loading) return /*#__PURE__*/_jsx(Loading, {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-3315130608" + " " + 'details',
      children: /*#__PURE__*/_jsxs("div", {
        className: "jsx-3315130608" + " " + 'info',
        children: [/*#__PURE__*/_jsxs("div", {
          className: "jsx-3315130608" + " " + (classnames('part-type', 'info-container', standardContainerPaddingStyle.className, standardContainerMarginStyle.className) || ""),
          children: [/*#__PURE__*/_jsx("div", {
            className: "jsx-3315130608" + " " + (labelStyle.className || ""),
            children: "Part"
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-3315130608" + " " + (valueStyle.className || ""),
            children: partInfo.partTypeName
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "jsx-3315130608" + " " + (classnames('vehicle', 'info-container', standardContainerPaddingStyle.className, standardContainerMarginStyle.className) || ""),
          children: [/*#__PURE__*/_jsx("div", {
            className: "jsx-3315130608" + " " + (labelStyle.className || ""),
            children: "Vehicle Information"
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-3315130608" + " " + (valueStyle.className || ""),
            children: [partInfo.modelYear, " ", partInfo.makeName, " ", partInfo.carlineName]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "jsx-3315130608" + " " + (classnames('misc', 'info-container', standardContainerPaddingStyle.className, standardContainerMarginStyle.className) || ""),
          children: [/*#__PURE__*/_jsxs("div", {
            className: "jsx-3315130608" + " " + 'item mileage',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (labelStyle.className || ""),
              children: "Mileage"
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (valueStyle.className || ""),
              children: partInfo.mileage ? formatNumber(partInfo.mileage) : /*#__PURE__*/_jsx("span", {
                className: "jsx-3315130608",
                children: "\u2014"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-3315130608" + " " + 'item rating',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (labelStyle.className || ""),
              children: "Part Rating"
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (valueStyle.className || ""),
              children: partInfo.partRating ? formatNumber(partInfo.partRating) : /*#__PURE__*/_jsx("span", {
                className: "jsx-3315130608",
                children: "\u2014"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-3315130608" + " " + 'item stock',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (labelStyle.className || ""),
              children: "Stock #"
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (valueStyle.className || ""),
              children: partInfo.stockTicketNumber ? partInfo.stockTicketNumber : /*#__PURE__*/_jsx("span", {
                className: "jsx-3315130608",
                children: "\u2014"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-3315130608" + " " + 'item conditions',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (labelStyle.className || ""),
              children: "Conditions & Options"
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (valueStyle.className || ""),
              children: partInfo.conditionsAndOptions || /*#__PURE__*/_jsx("span", {
                className: "jsx-3315130608",
                children: "\u2014"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-3315130608" + " " + 'item locationt t-xs',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (labelStyle.className || ""),
              children: "Location"
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-3315130608" + " " + (valueStyle.className || ""),
              children: partInfo.storeName ? partInfo.storeName : /*#__PURE__*/_jsx("span", {
                className: "jsx-3315130608",
                children: "\u2014"
              })
            })]
          })]
        })]
      })
    }), labelStyle.styles, valueStyle.styles, standardContainerPaddingStyle.styles, standardContainerMarginStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3315130608",
      children: [".info-container.jsx-3315130608{background:#F0F1F6;}", "@media(min-width:1200px){.misc.jsx-3315130608{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:30px;}}", ".misc.jsx-3315130608 .item.jsx-3315130608{margin-bottom:10px;display:block;}", "@media(min-width:576px){.misc.jsx-3315130608 .item.jsx-3315130608{display:grid;grid-template-columns:80px 1fr;margin-bottom:15px;}}", "@media(min-width:1200px){.misc.jsx-3315130608 .item.jsx-3315130608{display:block;margin-bottom:0;}}", ".misc.jsx-3315130608 .item.conditions.jsx-3315130608{display:block;}", "@media(min-width:576px){.misc.jsx-3315130608 .item.conditions.jsx-3315130608{margin-bottom:0;}}", ".misc.jsx-3315130608 .item.location.jsx-3315130608{margin-bottom:0;}", ".conditions.jsx-3315130608{grid-column:1 / span 3;}"]
    })]
  });
};

var PartActions = function PartActions(_ref8) {
  var loading = _ref8.loading,
      partInfo = _ref8.partInfo;
  if (loading) return null;
  var defaultWarrantyInfo = useDefaultWarrantyInfo();
  var config = useConfig();
  var hasCore = Boolean(partInfo.corePrice);

  var renderWarrantyInfo = function renderWarrantyInfo() {
    if (!defaultWarrantyInfo) return null;

    if (config.inventory.noWarrantyPartTypes.includes(partInfo.partType)) {
      return /*#__PURE__*/_jsxs("div", {
        className: "warranty",
        children: [/*#__PURE__*/_jsx("div", {
          className: labelStyle.className,
          children: "Warranty Option"
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("em", {
            children: "This part does not come with a warranty."
          })
        })]
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "jsx-3625372180" + " " + 'warranty',
          children: [/*#__PURE__*/_jsx("div", {
            className: "jsx-3625372180" + " " + (labelStyle.className || ""),
            children: "Warranty Option"
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-3625372180" + " " + (valueStyle.className || ""),
            children: [defaultWarrantyInfo.titleShort, "*"]
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-3625372180" + " " + 'adendum',
            children: "* Warranty options can be changed during checkout."
          })]
        }), /*#__PURE__*/_jsx(_JSXStyle, {
          id: "3625372180",
          children: [".adendum.jsx-3625372180{margin-top:5px;font-size:0.75rem;opacity:0.5;line-height:1.2;}"]
        })]
      });
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-2386551554" + " " + (classnames('container', standardContainerPaddingStyle.className) || ""),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "jsx-2386551554" + " " + (classnames('price', hasCore ? 'has-core' : '') || ""),
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-2386551554" + " " + (labelStyle.className || ""),
          children: "Price"
        }), /*#__PURE__*/_jsx("div", {
          className: "jsx-2386551554" + " " + (classnames('price-value', valueStyle.className) || ""),
          children: hasRetailPrice(partInfo.retailPrice) ? /*#__PURE__*/_jsx("span", {
            className: "jsx-2386551554" + " " + 'amount',
            children: formatDollars(partInfo.retailPrice)
          }) : /*#__PURE__*/_jsx("span", {
            className: "jsx-2386551554" + " " + 'make-offer-price',
            children: "Make an offer"
          })
        }), !hasCore ? null : /*#__PURE__*/_jsxs("div", {
          className: "jsx-2386551554" + " " + 'core',
          children: [/*#__PURE__*/_jsxs("div", {
            className: "jsx-2386551554" + " " + 'core-price',
            children: ["+ ", formatDollars(partInfo.corePrice), " Core Deposit"]
          }), /*#__PURE__*/_jsx(CoreChargeMessage, {})]
        })]
      }), renderWarrantyInfo(), /*#__PURE__*/_jsx("div", {
        className: "jsx-2386551554" + " " + 'actions',
        children: /*#__PURE__*/_jsx(PartCartActions, {
          partInfo: partInfo
        })
      })]
    }), labelStyle.styles, valueStyle.styles, standardContainerPaddingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2386551554",
      children: [".container.jsx-2386551554{background:#DBE9F9;}", ".price.jsx-2386551554{padding-bottom:12px;margin-bottom:12px;border-bottom:1px solid #9BA3C3;}", ".price.jsx-2386551554 .make-offer-price.jsx-2386551554{font-style:italic;}", ".price.jsx-2386551554 .price-value.jsx-2386551554{font-size:1.5rem;}", ".core.jsx-2386551554{margin-top:5px;font-style:italic;font-size:0.875rem;}", ".actions.jsx-2386551554{margin-top:10px;}"]
    })]
  });
};

var ShippingNote = function ShippingNote() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      className: "jsx-967632852",
      children: /*#__PURE__*/_jsx("em", {
        className: "jsx-967632852",
        children: "Shipping and In-Store Pick-Up options available during checkout."
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "967632852",
      children: ["p.jsx-967632852{font-size:0.75rem;}"]
    })]
  });
};

var PartLocation = function PartLocation(_ref9) {
  var loading = _ref9.loading,
      partInfo = _ref9.partInfo;
  if (loading) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-4067599691" + " " + (labelStyle.className || ""),
      children: "Part Location"
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-4067599691" + " " + (classnames('store-name', subHeadingStyle.className) || ""),
      children: partInfo.storeName || /*#__PURE__*/_jsx(_Fragment, {
        children: "\u2014"
      })
    }), /*#__PURE__*/_jsx(ShippingNote, {}), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "4067599691",
      children: [".store-name.jsx-4067599691{font-size:1.125rem;}"]
    })]
  });
};

var MobileContact = function MobileContact() {
  var config = useConfig();
  var chat = useChat();
  var content = chat.isAvailable ? 'Have questions or want to purchase? Call or chat with a dedicated Parts Expert.' : 'Have questions or want to purchase? Call a dedicated Parts Expert.';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-540485251" + " " + 'container',
      children: /*#__PURE__*/_jsxs("div", {
        className: "jsx-540485251" + " " + 'inner',
        children: [/*#__PURE__*/_jsx("p", {
          className: "jsx-540485251",
          children: /*#__PURE__*/_jsx("em", {
            className: "jsx-540485251",
            children: content
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "jsx-540485251",
          children: /*#__PURE__*/_jsx("a", {
            href: "tel:".concat(config.contact.phoneFull),
            className: "jsx-540485251" + " " + 'btn btn--blue--light btn--block btn--slim--lr',
            children: config.contact.phoneHuman
          })
        }), !chat.isAvailable ? null : /*#__PURE__*/_jsx("p", {
          className: "jsx-540485251",
          children: /*#__PURE__*/_jsx("button", {
            className: "jsx-540485251" + " " + 'btn btn--blue--dark btn--block btn--slim--lrk',
            children: "Live Chat"
          })
        })]
      })
    }), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "540485251",
      children: [".container.jsx-540485251{background:#DBE9F9;padding:20px;}", ".inner.jsx-540485251{margin:0 auto;max-width:325px;text-align:center;}"]
    })]
  });
};

var CallUs = function CallUs() {
  var config = useConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-1818893763" + " " + 'container',
      children: [/*#__PURE__*/_jsx("p", {
        className: "jsx-1818893763",
        children: /*#__PURE__*/_jsx("em", {
          className: "jsx-1818893763",
          children: "Call to purchase or speak with a dedicated Parts Expert."
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-1818893763",
        children: /*#__PURE__*/_jsx("a", {
          href: "tel:".concat(config.contact.phoneFull),
          className: "jsx-1818893763" + " " + (classnames('phone', subHeadingStyle.className) || ""),
          children: config.contact.phoneHuman
        })
      })]
    }), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1818893763",
      children: [".container.jsx-1818893763{padding-top:".concat(standardContainerPaddingTb, ";border-top:1px solid #9BA3C3;}"), ".phone.jsx-1818893763{font-size:1.125rem;}"]
    })]
  });
};

var ChatUs = function ChatUs() {
  var chat = useChat();
  if (!chat.isAvailable) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-258533413" + " " + 'container',
      children: [/*#__PURE__*/_jsx("p", {
        className: "jsx-258533413",
        children: /*#__PURE__*/_jsxs("em", {
          className: "jsx-258533413",
          children: ["Part or fit questions?", /*#__PURE__*/_jsx("br", {
            className: "jsx-258533413"
          }), "Chat with a Parts Expert."]
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-258533413",
        children: /*#__PURE__*/_jsx("button", {
          className: "jsx-258533413" + " " + 'btn btn--blue--dark btn--block btn--slim--lr',
          children: "Start Online Chat"
        })
      })]
    }), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "258533413",
      children: [".container.jsx-258533413{margin-top:".concat(standardContainerPaddingTb, ";padding-top:").concat(standardContainerPaddingTb, ";border-top:1px solid #9BA3C3;}")]
    })]
  });
};

var WarrantyInfo = function WarrantyInfo(_ref10) {
  var partInfo = _ref10.partInfo;
  var warrantyOptions = useWarrantyOptions();
  var config = useConfig();

  var renderOptions = function renderOptions() {
    if (config.inventory.noWarrantyPartTypes.includes(partInfo.partType)) {
      return /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("em", {
          children: "This part does not come with a warranty."
        })
      });
    } else {
      return /*#__PURE__*/_jsx("div", {
        className: "options",
        children: Object.entries(warrantyOptions).map(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              key = _ref12[0],
              info = _ref12[1];

          return /*#__PURE__*/_jsx(WarrantyOptionCard, {
            warrantyInfo: info
          }, key);
        })
      });
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "warranty-info",
      children: [/*#__PURE__*/_jsx("h3", {
        className: subHeadingStyle.className,
        children: "Warranty Options"
      }), /*#__PURE__*/_jsxs("p", {
        children: ["Options available during checkout. All warranty options are subject to our ", /*#__PURE__*/_jsx(Link, {
          href: "/legal/terms",
          children: /*#__PURE__*/_jsx("a", {
            children: "terms & conditions"
          })
        }), "."]
      }), renderOptions()]
    }), subHeadingStyle.styles]
  });
};

var InspectionVideo = function InspectionVideo() {
  var config = useConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-4168425665" + " " + 'inspection',
      children: [/*#__PURE__*/_jsx("h3", {
        className: "jsx-4168425665" + " " + (subHeadingStyle.className || ""),
        children: "Transmission Inspection Video"
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-4168425665",
        children: "Quick demo of the removal and inspection process all of our transmission go through before shipping."
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-4168425665" + " " + 'video',
        children: /*#__PURE__*/_jsx(Youtube, {
          url: config.media.transmissionInspectionVideoUrl
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-4168425665",
        children: /*#__PURE__*/_jsx(Link, {
          href: "/about/videos",
          children: /*#__PURE__*/_jsx("a", {
            className: "jsx-4168425665",
            children: "View more autowrecking videos \xBB"
          })
        })
      })]
    }), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "4168425665",
      children: [".video.jsx-4168425665{width:100%;height:307px;}", "@media(max-width:504px){.video.jsx-4168425665{height:230px;}}", "@media(min-width:768px){.video.jsx-4168425665{height:245px;}}", "@media(min-width:1200px){.video.jsx-4168425665{height:177px;}}"]
    })]
  });
};

var Feedback = function Feedback() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-3822985375" + " " + 'feedback',
      children: [/*#__PURE__*/_jsx("h3", {
        className: "jsx-3822985375" + " " + (subHeadingStyle.className || ""),
        children: "Autowrecking.com Customer Feedback"
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-3822985375",
        children: "\"I use B&R for all my pickup truck parts needs! There are clean & rust free parts and they ship them wrapped up, ship on a pallet depending the size of that part. Give them a call next time you need something for any year, make & model! You'll be glad you did.\""
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-3822985375",
        children: "\u2014 Jesus Navarro"
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-3822985375",
        children: /*#__PURE__*/_jsx(Link, {
          href: "/about/reviews",
          children: /*#__PURE__*/_jsx("a", {
            className: "jsx-3822985375",
            children: "Read more customer feedback \xBB"
          })
        })
      })]
    }), subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3822985375",
      children: [".video.jsx-3822985375{width:100%;height:235px;}"]
    })]
  });
};

var mapStateToProps = function mapStateToProps(_ref13) {
  var config = _ref13.config,
      media = _ref13.media,
      _ref13$parts = _ref13.parts,
      inventory = _ref13$parts.inventory,
      partTypeName = _ref13$parts.partTypeName;
  return {
    media: media,
    partTypeNameStore: partTypeName,
    inventory: inventory,
    config: config
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      addRecentlyViewed: addRecentlyViewed
    }, dispatch)
  };
};

var recentlyViewedStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "3010679073",
    children: [".jsx-3010679073{margin:20px 0;}"]
  }),
  className: "jsx-3010679073"
};
var Page = withErrorPage(function (_ref14) {
  var config = _ref14.config,
      inventory = _ref14.inventory,
      media = _ref14.media,
      actions = _ref14.actions,
      partTypeNameStore = _ref14.partTypeNameStore,
      entity = _ref14.entity;
  var partInfo = entity;
  var doing = inventory.one.doing;
  var lastSearch = useLastSearch();
  loadVehiclePhotos(partInfo.araVehicleId);
  loadInventoryPhotos(partInfo.inventoryId);
  useEffect(function () {
    if (!partInfo) return;
    actions.addRecentlyViewed(partInfo);
  }, []);
  var summary = getPartSummary(partInfo);

  var searchParams = function () {
    if (doing) return {
      doing: true
    };
    if (!partInfo) return {
      doing: false
    };

    if (lastSearch) {
      return {
        doing: false,
        partTypeSlug: lastSearch.part,
        year: lastSearch.year,
        make: lastSearch.make,
        carline: lastSearch.model,
        application: lastSearch.app
      };
    }

    return {
      doing: false,
      partTypeSlug: partInfo.partTypeSlug,
      year: partInfo.modelYear,
      make: partInfo.makeName,
      carline: partInfo.carlineName
    };
  }();

  return /*#__PURE__*/_jsxs(Layout, {
    title: summary,
    children: [/*#__PURE__*/_jsxs(SubLayoutGraySidebar, {
      children: [/*#__PURE__*/_jsxs(Sidebar, {
        className: "a-md",
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-4178876246" + " " + 'search',
          children: /*#__PURE__*/_jsx(PartSearchFormSidebar, _objectSpread({}, searchParams))
        }), /*#__PURE__*/_jsx(FeaturedPartTypesSidebar, {})]
      }), /*#__PURE__*/_jsxs(Main, {
        children: [/*#__PURE__*/_jsx(PartHeading, {
          loading: doing,
          partInfo: partInfo
        }), /*#__PURE__*/_jsxs("div", {
          className: "jsx-4178876246" + " " + 'info',
          children: [/*#__PURE__*/_jsx("div", {
            className: "jsx-4178876246" + " " + 'photos',
            children: /*#__PURE__*/_jsx(PartPhotos, {
              loading: doing,
              partInfo: partInfo,
              media: media,
              config: config
            })
          }), /*#__PURE__*/_jsx(PartDetails, {
            loading: doing,
            partInfo: partInfo
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-4178876246" + " " + 'part-sidebar',
            children: [/*#__PURE__*/_jsx(PartActions, {
              loading: doing,
              partInfo: partInfo
            }), /*#__PURE__*/_jsxs("div", {
              className: "jsx-4178876246" + " " + (classnames('a-sm', standardContainerPaddingStyle.className) || ""),
              children: [/*#__PURE__*/_jsx(PartLocation, {
                loading: doing,
                partInfo: partInfo
              }), /*#__PURE__*/_jsx(CallUs, {}), /*#__PURE__*/_jsx(ChatUs, {})]
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-4178876246" + " " + (classnames('t-xs', standardContainerPaddingStyle.className) || ""),
              children: /*#__PURE__*/_jsx(ShippingNote, {})
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-4178876246" + " " + 'mobile-contact t-xs',
            children: /*#__PURE__*/_jsx(MobileContact, {})
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-4178876246" + " " + 'warranty-inspection',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-4178876246" + " " + 'warranty',
              children: /*#__PURE__*/_jsx(WarrantyInfo, {
                partInfo: partInfo
              })
            }), /*#__PURE__*/_jsx(InspectionVideo, {})]
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-4178876246" + " " + 'feedback',
            children: /*#__PURE__*/_jsx(Feedback, {})
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(RecentlyViewedParts, {
      className: recentlyViewedStyle.className
    }), recentlyViewedStyle.styles, standardContainerPaddingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "4178876246",
      children: [".search.jsx-4178876246{margin-bottom:20px;}", ".info.jsx-4178876246{display:grid;grid-gap:5px;grid-template-columns:6fr 4fr;}", "@media(max-width:504px){.info.jsx-4178876246{grid-template-columns:1fr 1fr;}}", "@media(min-width:992px){.info.jsx-4178876246{grid-template-columns:250px 1fr 224px;}}", "@media(min-width:1200px){.info.jsx-4178876246{grid-template-columns:350px 1fr 224px;}}", ".photos.jsx-4178876246{grid-column:auto / span 2;}", "@media(min-width:992px){.photos.jsx-4178876246{grid-column:auto;}}", ".part-sidebar.jsx-4178876246{grid-row:auto / span 3;}", ".mobile-contact.jsx-4178876246{grid-column:auto / span 2;}", ".warranty-inspection.jsx-4178876246{grid-column:auto / span 2;border-top:1px solid #9BA3C3;border-bottom:1px solid #9BA3C3;margin:20px 0;padding:20px 0;}", "@media(min-width:1200px){.warranty-inspection.jsx-4178876246{display:grid;grid-template-columns:5fr 5fr;grid-gap:32px;}}", ".warranty.jsx-4178876246{border-bottom:1px solid #9BA3C3;padding-bottom:20px;margin-bottom:20px;}", "@media(min-width:1200px){.warranty.jsx-4178876246{border:0;padding:0;margin:0;}}", ".feedback.jsx-4178876246{grid-column:auto / span 2;}"]
    })]
  });
});

Page.getInitialProps = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref15) {
    var deps, store, query, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            deps = _ref15.deps, store = _ref15.store, query = _ref15.query, res = _ref15.res;
            return _context.abrupt("return", respondStatus(res, store.dispatch(getOnePart(deps.tokenCache, query.id))));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref16.apply(this, arguments);
  };
}();

var ExportPage = connect(mapStateToProps, mapDispatchToProps)(Page);
export default ExportPage;